import $ from "jquery";
import moment from "moment";
import React, { Component } from "react";
import "react-datepicker/dist/react-datepicker.css";
import Datetime from "react-datetime";
import { Redirect } from "react-router-dom";
import { Treebeard } from "react-treebeard";
import Comm from "../comm/comm";
import Context from "../context/context";
import Translation from "../translation/translation";

class Theme {
    tree = {
        base: {
            listStyle: "none",
            backgroundColor: "#FFFFFF",
            margin: 0,
            padding: 0,
            color: "#DDDDDD",
            fontFamily: "lucida grande ,tahoma,verdana,arial,sans-serif",
            fontSize: "12px",
        },
        node: {
            base: {
                position: "relative",
            },
            link: {
                cursor: "pointer",
                position: "relative",
                padding: "0px 5px",
                display: "block",
            },
            activeLink: {
                background: "#DDDDDD",
            },
            toggle: {
                base: {
                    position: "relative",
                    display: "inline-block",
                    verticalAlign: "top",
                    marginLeft: "-5px",
                    height: "18px",
                    width: "18px",
                },
                wrapper: {
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    margin: "-7px 0 0 -7px",
                    height: "10px",
                },
                height: 12,
                width: 12,
                arrow: {
                    fill: "#000000",
                    strokeWidth: 0,
                },
            },
            header: {
                base: {
                    display: "inline-block",
                    verticalAlign: "top",
                    color: "#000000",
                },
                connector: {
                    width: "2px",
                    height: "12px",
                    borderLeft: "solid 2px black",
                    borderBottom: "solid 2px black",
                    position: "absolute",
                    top: "0px",
                    left: "-21px",
                },
                title: {
                    lineHeight: "12px",
                    verticalAlign: "middle",
                },
            },
            subtree: {
                listStyle: "none",
                paddingLeft: "19px",
            },
            loading: {
                color: "#E2C089",
            },
        },
    };
}

class Deliveries extends Component {
    CurrentArticleId;

    GetNode(t) {
        var node = {
            id: t.id,
            name: t.name,
            opened: false,
            selected: false,
            children: [],
        };
        if (t.childs)
            for (var iter = 0; iter < t.childs.length; iter++) {
                var i = t.childs[iter];
                node.children.push(this.GetNode(i));
            }

        return node;
    }
    constructor(props) {
        super(props);
        if (!Comm.ValidSession()) return;

        if (!Context.IsLogged()) {
            return;
        }
        var sid = Context.GetContext().Sid;

        var tree = Comm.GetArticleTree({ session: sid });
        var treeData = [];
        for (var t of tree) {
            treeData.push(this.GetNode(t));
        }

        var partners = Comm.Partners(sid);
        var taxGroups = Comm.CallServerFunction("invoices/tax_groups", { session: sid });

        this.state = {
            TreeData: treeData,
            Partners: partners,
            inv_dt: moment(),
            Articles: [],
            DialogMode: "delivery",
            TaxGroups: taxGroups.data.tax_groups,
            DefaultTaxGroup: taxGroups.data.default_group,
            on_the_road: this.props.match.params.on_the_road === "true",
        };

        this.ChangeInvDate = this.ChangeInvDate.bind(this);
        this.onToggle = this.onToggle.bind(this);
        this.CancelArticle = this.CancelArticle.bind(this);
        this.SaveArticle = this.SaveArticle.bind(this);
        this.ChangeWeight = this.ChangeWeight.bind(this);
        this.DelArticle = this.DelArticle.bind(this);
        this.SaveDelivery = this.SaveDelivery.bind(this);
    }

    SaveDelivery() {
        this.setState({ ShowInvoiceNumberError: false });
        if ($("#tbInvoiceNumber").val() === "") {
            this.setState({ ShowInvoiceNumberError: true });
            return;
        }
        var sid = Context.GetContext().Sid;
        var data = {
            session: sid,
            partner: $("#ddlPartner").val(),
            dt: moment().format("YYYYMMDD HH:mm:ss"),
            inv_dt: moment(this.state.inv_dt).format("YYYYMMDD"),
            inv_nom: $("#tbInvoiceNumber").val(),
            currency: $("#tbCurrency").val(),
            exchange_rate: parseFloat($("#tbExchangeRate").val()) || 1,
            tax_group: $("#ddlTaxGroup").val(),
            on_the_road: this.state.on_the_road,
        };
        var packets = [];
        for (var i = 0; i < this.state.Articles.length; i++)
            packets.push({
                article: this.state.Articles[i].ArticleId,
                cnt: this.state.Articles[i].Count,
                weight: this.state.Articles[i].Weight,
                price: this.state.Articles[i].Price,
            });

        data.packets = JSON.stringify(packets);
        Comm.SaveDelivery(data);
        $("#tbInvoiceNumber").val("");
        $("#tbCurrency").val("");
        $("#tbExchangeRate").val("");
        this.setState({ Articles: [] });
        $("#dSuccess").show();
        $("#dSuccess").fadeOut(3000);
    }

    DelArticle(id) {
        var articles = this.state.Articles;
        articles.splice(id, 1);
        this.setState({ Articles: articles });
    }

    ChangeWeight() {
        this.setState({
            PacketCount: parseInt($("#tbPacketCount").val(), 10),
            SingleWeight: parseFloat($("#tbSingleWeight").val()),
        });
    }

    CancelArticle() {
        this.setState({ DialogMode: "delivery" });
    }

    SaveArticle() {
        var result = true;
        this.setState({
            ShowArticleNameError: false,
            ShowPriceForKgError: false,
            ShowSingleWeightError: false,
            ShowPacketCountError: false,
        });
        var priceforkg = parseFloat($("#tbPriceForKg").val());
        var packetcount = parseInt($("#tbPacketCount").val(), 10);
        var singleweight = parseFloat($("#tbSingleWeight").val());
        if (this.state.SelectedArticleId === null) {
            this.setState({ ShowArticleNameError: true });
            result = false;
        }
        if (!priceforkg || priceforkg === 0) {
            this.setState({ ShowPriceForKgError: true });
            result = false;
        }
        if (!packetcount || packetcount === 0) {
            this.setState({ ShowPacketCountError: true });
            result = false;
        }
        if (!singleweight || singleweight === 0) {
            this.setState({ ShowSingleWeight: true });
            result = false;
        }

        if (!result) return;
        var articles = this.state.Articles;
        var item = {
            ArticleName: this.state.SelectedArticleName,
            ArticleId: this.state.SelectedArticleId,
            Count: packetcount,
            Weight: singleweight,
            Total: packetcount * singleweight,
            Price: priceforkg,
        };

        if (this.state.CurrentArticleId) articles[this.state.CurrentArticleId] = item;
        else articles.push(item);

        this.setState({ DialogMode: "delivery", Articles: articles });
    }

    onToggle(node, toggled) {
        // if (this.state.cursor) {
        //     this.state.cursor.active = false;
        // }
        this.setState((prevState) => {
            let cursor = prevState.cursor;
            if (cursor) {
                cursor = { ...cursor, active: false };
            }
            return { cursor };
        });
        node.active = true;
        if (node.children) {
            node.toggled = toggled;
        }
        this.setState({
            SelectedArticleName: node.name,
            SelectedArticleId: node.id,
            ShowArticleNameError: false,
        });
    }

    ChangeInvDate(date) {
        this.setState({ inv_dt: moment(date) });
    }

    EditArticle(articleId) {
        if (articleId === null) {
            this.setState({
                DialogMode: "article",
                partner: $("#ddlPartner").val(),
                inv_dt: moment(this.state.inv_dt),
                inv_nom: $("#tbInvoiceNumber").val(),
                currency: $("#tbCurrency").val(),
                exchange_rate: $("#tbExchangeRate").val(),
                DefaultTaxGroup: $("#ddlTaxGroup").val(),
                on_the_road: this.state.on_the_road,
                SelectedArticleId: null,
                SelectedArticleName: null,
                PriceForKg: 0,
                PacketCount: 0,
                SingleWeight: 0,
                CurrentArticleId: null,
            });
        } else {
            var item = this.state.Articles[articleId];

            this.setState({
                DialogMode: "article",
                partner: $("#ddlPartner").val(),
                inv_dt: moment(this.state.inv_dt).format("YYYYMMDD"),
                inv_nom: $("#tbInvoiceNumber").val(),
                currency: $("#tbCurrency").val(),
                exchange_rate: $("#tbExchangeRate").val(),
                DefaultTaxGroup: $("#ddlTaxGroup").val(),
                SelectedArticleName: item.ArticleName,
                SelectedArticleId: item.ArticleId,
                PriceForKg: item.Price,
                PacketCount: item.Count,
                SingleWeight: item.Weight,
                CurrentArticleId: articleId,
            });
        }
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }
        if (Context.RenderNotOK(this.props.history)) return null;

        var self = this;
        var t = new Theme();

        return Context.HasRight("rdeliveries") ? (
            <div className="panel panel-default">
                <div className="panel-heading">
                    {this.state.on_the_road
                        ? Translation.Trans("deliveriesonroad")
                        : Translation.Trans("deliveries")}
                </div>
                <div className="panel-body">
                    {this.state.DialogMode === "delivery" ? (
                        <div className="col-md-12">
                            <div className="col-md-4">{Translation.Trans("contragent")}</div>
                            <div className="col-md-8">
                                <select
                                    id="ddlPartner"
                                    className="form-control"
                                    defaultValue={this.state.partner}
                                >
                                    {this.state.Partners.map((item) => (
                                        <option value={item.id}>{item.name}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-4">{Translation.Trans("invoicedate")}</div>
                            <div className="col-md-8">
                                <Datetime
                                    inputProps={{
                                        placeholder: "N/A",
                                        readOnly: "true",
                                        className: "form-control pointhand",
                                    }}
                                    id="dpStartDate"
                                    value={this.state.inv_dt}
                                    onChange={this.ChangeInvDate}
                                    dateFormat="DD.MM.YYYY"
                                    readOnly="true"
                                    closeOnSelect="true"
                                ></Datetime>
                            </div>

                            <div className="col-md-4">{Translation.Trans("invoicenumber")}</div>
                            <div className="col-md-8">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="tbInvoiceNumber"
                                    defaultValue={this.state.inv_nom}
                                />
                                {this.state.ShowInvoiceNumberError ? (
                                    <div className="alert alert-danger">
                                        {Translation.Trans("entervalue")}
                                    </div>
                                ) : null}
                            </div>
                            <div className="col-md-4">{Translation.Trans("currency")}</div>
                            <div className="col-md-8">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="tbCurrency"
                                    defaultValue={this.state.currency}
                                />
                            </div>
                            <div className="col-md-4">{Translation.Trans("exchangerate")}</div>
                            <div className="col-md-8">
                                <input
                                    type="number"
                                    className="form-control"
                                    id="tbExchangeRate"
                                    defaultValue={this.state.exchange_rate}
                                />
                            </div>
                            <div className="col-md-4">{Translation.Trans("taxgroup")}</div>
                            <div className="col-md-8">
                                <select
                                    className="form-control"
                                    defaultValue={self.state.DefaultTaxGroup}
                                    id="ddlTaxGroup"
                                >
                                    {self.state.TaxGroups.map((x) => (
                                        <option value={x.id}>
                                            {x.code} {x.dds_perc}%
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-4">
                                <button className="btn btn-default" onClick={() => this.EditArticle(null)}>
                                    <span class="glyphicon glyphicon-plus" aria-hidden="true"></span>
                                </button>
                            </div>
                            <div className="col-md-4">
                                {Context.HasRight("edeliveries") ? (
                                    <button className="btn btn-default" onClick={() => this.SaveDelivery()}>
                                        {Translation.Trans("save")}
                                    </button>
                                ) : null}
                                <div id="dSuccess" class="alert alert-success" style={{ display: "none" }}>
                                    {Translation.Trans("successsave")}
                                </div>
                            </div>
                            <div className="col-md-4"></div>
                            <p>&nbsp;</p>
                            <div className="col-md-12">
                                <table class="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>{Translation.Trans("article")}</th>
                                            <th>{Translation.Trans("count")}</th>
                                            <th>{Translation.Trans("weight")}</th>
                                            <th>{Translation.Trans("total")}</th>
                                            <th>{Translation.Trans("price")}</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.Articles.map((item, index) => (
                                            <tr>
                                                <td>{item.ArticleName}</td>
                                                <td>{item.Count}</td>
                                                <td>{item.Weight}</td>
                                                <td>{item.Total}</td>
                                                <td>{item.Price}</td>
                                                <td>
                                                    <button
                                                        className="btn btn-default"
                                                        onClick={() => this.DelArticle(index)}
                                                    >
                                                        X
                                                    </button>
                                                    <button
                                                        className="btn btn-default"
                                                        onClick={() => this.EditArticle(index)}
                                                    >
                                                        <span
                                                            class="glyphicon glyphicon-pencil"
                                                            aria-hidden="true"
                                                        ></span>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    ) : null}
                    {this.state.DialogMode === "article" ? (
                        <div className="row">
                            <div className="col-md-4">
                                <Treebeard
                                    data={this.state.TreeData}
                                    onToggle={this.onToggle}
                                    style={t}
                                ></Treebeard>
                            </div>
                            <div className="col-md-8">
                                <div className="col-md-4">{Translation.Trans("selectedarticle")}</div>
                                <div className="col-md-8">
                                    <label id="lArticleName">{this.state.SelectedArticleName}</label>
                                    {this.state.ShowArticleNameError ? (
                                        <div className="alert alert-danger">
                                            {Translation.Trans("entervalue")}
                                        </div>
                                    ) : null}
                                </div>
                                <div className="col-md-4">{Translation.Trans("priceforkg")}</div>
                                <div className="col-md-8">
                                    <input
                                        id="tbPriceForKg"
                                        type="number"
                                        class="form-control"
                                        defaultValue={this.state.PriceForKg}
                                    />
                                    {this.state.ShowPriceForKgError ? (
                                        <div className="alert alert-danger">
                                            {Translation.Trans("entercorrectvalue")}
                                        </div>
                                    ) : null}
                                </div>
                                <div className="col-md-4">{Translation.Trans("packetcount")}</div>
                                <div className="col-md-8">
                                    <input
                                        id="tbPacketCount"
                                        type="number"
                                        min="0"
                                        step="1"
                                        class="form-control"
                                        defaultValue={this.state.PacketCount}
                                        onChange={() => this.ChangeWeight()}
                                    />
                                    {this.state.ShowPacketCountError ? (
                                        <div className="alert alert-danger">
                                            {Translation.Trans("entercorrectvalue")}
                                        </div>
                                    ) : null}
                                </div>
                                <div className="col-md-4">{Translation.Trans("singleweight")}</div>
                                <div className="col-md-8">
                                    <input
                                        id="tbSingleWeight"
                                        type="number"
                                        min="0"
                                        step="1"
                                        class="form-control"
                                        defaultValue={this.state.SingleWeight}
                                        onChange={() => this.ChangeWeight()}
                                    />
                                    {this.state.ShowSingleWeight ? (
                                        <div className="alert alert-danger">
                                            {Translation.Trans("entercorrectvalue")}
                                        </div>
                                    ) : null}
                                </div>
                                <div className="col-md-6">
                                    <button className="btn btn-default" onClick={() => this.SaveArticle()}>
                                        {Translation.Trans("save")}
                                    </button>
                                    <button className="btn btn-default" onClick={() => this.CancelArticle()}>
                                        {Translation.Trans("cancel")}
                                    </button>
                                </div>
                                <div className="col-md-6">
                                    <div className="pull-right">
                                        {Translation.Trans("totalweight")}
                                        <label id="lTotalWeight">
                                            {this.state.PacketCount * this.state.SingleWeight}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
        ) : (
            <div>{Translation.Trans("noRights")}</div>
        );
    }
}

export default Deliveries;



// WEBPACK FOOTER //
// ./src/pages/deliveries.js